export default __webpack_public_path__ + "static/media/rohit_resume.f2a1209b.pdf";